module.exports = __webpack_public_path__ + "img/Group 6831@2x.f848a13e.png";